import type { ReactNode } from 'react';
import cx from 'clsx';
import styles from './nav-sidebar.module.css';

function SidebarRoot({
  children,
  className,
  ...props
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <aside className={cx(styles.sidebar, className)} {...props}>
      <div className={styles.content}>{children}</div>
    </aside>
  );
}

function Main({ children, className, ...props }: { children: ReactNode; className?: string }) {
  return (
    <div className={cx(styles.main, className)} {...props}>
      {children}
    </div>
  );
}

function Header({ children, className, ...props }: { children?: ReactNode; className?: string }) {
  return (
    <header className={cx(styles.header, className)} {...props}>
      {children}
    </header>
  );
}

function Footer({ children, className, ...props }: { children?: ReactNode; className?: string }) {
  return (
    <footer className={cx(styles.footer, className)} {...props}>
      {children}
    </footer>
  );
}

export const NavSidebar = Object.assign(SidebarRoot, { Header, Main, Footer });
